import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyCEXpwSIV8zGGp3wV7KQiIZdtWdI_pwMT0",
    authDomain: "sailing-log.firebaseapp.com",
    projectId: "sailing-log",
    storageBucket: "sailing-log.appspot.com",
    messagingSenderId: "803530819126",
    appId: "1:803530819126:web:a30e18a31b7363fa68fa97",
  });
} else {
  firebase.app();
}

class FirebaseConnection {
  firestore = firebase.firestore();
  entriesRef = this.firestore.collection("Entries");

  async readData(selSkipper, yearFrom = 22) {
    const tempEntries = [];
    const entries =
      selSkipper === "*"
        ? await this.entriesRef.get()
        : await this.entriesRef.where("skipper", "==", selSkipper).get();

    entries.forEach((entry) => {
      const data = { ...entry.data(), id: entry.id };

    if(data.date.slice(-2) === yearFrom )  tempEntries.push(data);
    });

    return tempEntries;
  }

  async writeData(skipper, date, duration, comment) {
    await this.entriesRef.add({
      skipper: skipper,
      date: date,
      duration: duration,
      comment: comment,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  async deleteData(id) {
    await this.entriesRef.doc(id).delete();
  }
}

export default FirebaseConnection;
